var map = {
	"./custom.png": 66,
	"./fasting.png": 64,
	"./gain_weight.png": 61,
	"./healthy.png": 60,
	"./keto.png": 58,
	"./medical.png": 63,
	"./nutritient.png": 65,
	"./vegan.png": 59,
	"./wedding.png": 62
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 308;